import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Stack, Button, useTheme } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { TimeRange } from './types';
import { CalendarIcon } from '@mui/x-date-pickers';

export function TimeRangeBar({ range, onChange }: { range: TimeRange; onChange: (r: TimeRange) => void }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
      <ToggleButtonGroup size="small"
        exclusive
        value={range}
        onChange={(_, v) => v && onChange(v)}
        aria-label="time range">
        {[
          { value: '7d', label: '7 days' },
          { value: '30d', label: '30 days' },
          { value: '60d', label: '60 days' },
          { value: '90d', label: '90 days' },
        ].map(({ value, label }) => (
          <ToggleButton
            sx={{
              px: '12px',
              backgroundColor: theme.palette.common.white,
              color: theme.palette.common.black,
              border: '1px solid rgba(0, 0, 0, 0.12)',
              borderLeft: '1px solid rgba(0, 0, 0, 0.12) !important',
              textTransform: 'lowercase',
              borderRadius: '8px',

              '&.Mui-selected': {
                backgroundColor: theme.palette.custom.gray[100],
                '&:hover': {
                  backgroundColor: theme.palette.custom.gray[100],
                },
              },
            }}
            key={value}
            value={value}>{label}</ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Stack direction="row"
        spacing={4}>
        <Button
          startIcon={<CalendarIcon />}
          sx={{
            borderRadius: '8px',
            borderColor: '#D0D5DD',
            color: '#344054',
            backgroundColor: '#F9FAFB',
            fontWeight: 500,
            textTransform: 'none',
            height: '38px',
            px: 4,
            py: '6px',
            fontSize: 14,
            '&:hover': { borderColor: '#D0D5DD', backgroundColor: '#F9FAFB' },
          }}>
          Select rota
        </Button>
        <Button
          startIcon={<FilterList />}
          sx={{
            borderRadius: '8px',
            borderColor: '#D0D5DD',
            backgroundColor: '#F9FAFB',
            color: '#344054',
            fontWeight: 500,
            textTransform: 'none',
            height: '38px',
            px: 4,
            py: '6px',
            fontSize: 14,
            '&:hover': { borderColor: '#D0D5DD', backgroundColor: '#F9FAFB' },
          }}>
          Filters
        </Button>
      </Stack>
    </Box>
  );
}
